import { useEffect, useMemo, useState } from "react";
import { useLenis } from "../hooks/useLenis";
import { LAUNCH_DATE } from "../config";
import { BlueprintBg } from "../components/BlueprintBg";
import { FloatingNav } from "../components/FloatingNav";
import { Hero } from "../components/Hero";
import { Countdown } from "../components/Countdown";
import { Manifesto } from "../components/Manifesto";
import { Marquee } from "../components/Marquee";
import { BrandEvolution } from "../components/BrandEvolution";
import { PostLaunch } from "../components/PostLaunch";
import { Footer } from "../components/Footer";

export default function ComingSoon() {
  useLenis();

  // Preview override via ?preview=live | ?preview=soon
  const preview = useMemo(() => {
    return new URLSearchParams(window.location.search).get("preview");
  }, []);

  const computeLaunched = () => {
    if (preview === "live") return true;
    if (preview === "soon") return false;
    return Date.now() >= LAUNCH_DATE.getTime();
  };

  const [isLaunched, setIsLaunched] = useState(computeLaunched);

  // Auto-switch to the "Live" state exactly at launch time — no refresh needed.
  useEffect(() => {
    if (preview === "live" || preview === "soon") return; // forced state
    if (isLaunched) return;
    const id = setInterval(() => {
      if (Date.now() >= LAUNCH_DATE.getTime()) {
        setIsLaunched(true);
        clearInterval(id);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 1000);
    return () => clearInterval(id);
  }, [isLaunched, preview]);

  return (
    <div className="relative min-h-screen overflow-x-hidden">
      <BlueprintBg />
      <FloatingNav />

      {isLaunched ? (
        <main data-testid="state-launched">
          <PostLaunch />
          <Footer />
        </main>
      ) : (
        <main data-testid="state-coming-soon" className="pt-0">
          <Hero />
          <Countdown />
          <Marquee />
          <BrandEvolution />
          <Manifesto />
          <Footer />
        </main>
      )}
    </div>
  );
}
